import { useMemo } from 'react';
import { modals } from '@modals';
import { useShowHide } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$hooks';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';

interface AllBenefitsOutput {
	resources: AllBenefitsResources;
	onCloseRequest: () => void;
}

interface AllBenefitsResources {
	subtitle: string;
	benefits: string;
	annualFees: string;
	stampDuty: string;
	additionalNote: string;
}

export const useAllBenefits = (): AllBenefitsOutput => {
	const t = useTranslation();
	const { hide } = useShowHide(modals.allBenefits);

	const resources = useMemo((): AllBenefitsResources => {
		return {
			subtitle: t('modals.allBenefits.subtitle'),
			benefits: t('modals.allBenefits.benefits'),
			annualFees: t('modals.allBenefits.annualFees'),
			stampDuty: t('modals.allBenefits.stampDuty'),
			additionalNote: t('modals.allBenefits.additionalNote'),
		};
	}, [t]);

	const onCloseRequest = () => {
		hide();
	};

	return { resources, onCloseRequest };
};
